<template>
  <CarouselSlide class="before-slide">
    <FeaturesList
      class="before-slide__list"
      title="Було"
      list-type="simple"
      :items="getBeforeItems"
      :image-components="getBeforeImageComponents"
    />
  </CarouselSlide>
</template>

<script>
import FeaturesList from '../../features-list';
import { textBlock } from '@/entities/text-block';
import {
  AbacusImage,
  BookmarkTabsImage,
  CryingFaceImage,
  MoaiImage,
  MoneyWithWingsImage,
  TornadoImage,
} from '@/shared/ui/promo';
import { CarouselSlide } from '@/shared/ui/slider';

export default {
  mixins: [ textBlock ],
  components: { CarouselSlide, FeaturesList },
  computed: {
    getBeforeImageComponents() {
      return {
        TornadoImage,
        CryingFaceImage,
        AbacusImage,
        BookmarkTabsImage,
        MoneyWithWingsImage,
        MoaiImage,
      };
    },
    getBeforeItems() {
      return [
        {
          icon: 'TornadoImage',
          text: this.getListBlock('promo', 'connect-features-before')[0],
        },
        {
          icon: 'CryingFaceImage',
          text: this.getListBlock('promo', 'connect-features-before')[1],
        },
        {
          icon: 'AbacusImage',
          text: this.getListBlock('promo', 'connect-features-before')[2],
        },
        {
          icon: 'BookmarkTabsImage',
          text: this.getListBlock('promo', 'connect-features-before')[3],
        },
        {
          icon: 'MoneyWithWingsImage',
          text: this.getListBlock('promo', 'connect-features-before')[4],
        },
        {
          icon: 'MoaiImage',
          text: this.getListBlock('promo', 'connect-features-before')[5],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.before-slide {
  padding: 0 16px 70px;
}
</style>
